import Pig from "@/icons/pig.svg?react";
import Message from "@/components/Message";

interface ReactivatedUserMessageProps {
  email?: string;

  /**
   * Called when the user closes the message, so the caller can persist the
   * dismissal (the message must not come back after a reload).
   */
  onClose?: () => void;
}

const ReactivatedUserMessage = ({
  email,
  onClose,
}: ReactivatedUserMessageProps) => {
  return (
    <Message type="small" closeable={true} onCloseClick={onClose}>
      <h1 className="mb-4 text-lg font-bold">Vítejte zpátky!</h1>
      Jsme rádi, že jste si to rozmysleli a máme vás zase v Trendaří rodině.
      <br />
      Obnovujeme vám účet <b>{email}</b>
      <br />a přejeme, ať <Pig className="icon-sm fill-[#a56c43]" /> rychle
      přibývají.
      <br />
      <br />
      Tým Trendaro
    </Message>
  );
};

export default ReactivatedUserMessage;
